import React, {Component} from "react";
import {Button} from "primereact/button";
import {Growl} from 'primereact/growl';
import {REG_EXP_EMAIL} from "../../utils/constants/Constants";
import {EmailAdminService} from "../../service/admin/email/EmailAdminService";
import EmailAdmin from "./EmailAdminView";
import ConfirmationMessage from "../../components/confirmationMessage"

export default class EmailAdminContainer extends Component {
    constructor(props) {
        super(props);
        this.reExpEmail = REG_EXP_EMAIL;
        this.emailAdminService = new EmailAdminService();

        this.getDataEmail = this.getDataEmail.bind(this);

        this.state = {
            dataEmails: this.getDataEmail(''),
            emailSearch: '',
            emailDelete: '',
            isLoading: true,
        };

        this.addNewEmail = this.addNewEmail.bind(this);
        this.saveEmail = this.saveEmail.bind(this);
        this.deleteEmail = this.deleteEmail.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.onChangeTextDialog = this.onChangeTextDialog.bind(this);
        this.onChangeTextFilter = this.onChangeTextFilter.bind(this);
        this.emailActionTemplate = this.emailActionTemplate.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.searchEmail = this.searchEmail.bind(this);
        this.loading = this.loading.bind(this);
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    fillDataEmails(dataEmails) {
        this.setState({
            dataEmails: dataEmails,
            isLoading: false,
        })
    }

    getDataEmail(email) {
        this.loading();
        return this.emailAdminService.getEmailAdmin(email)
            .then(dataEmails => this.fillDataEmails(dataEmails))
    }

    addNewEmail() {
        this.newEmail = true;
        this.setState({
            email: {emailStr: '',},
            displayDialog: true,
        });
    }

    saveEmail() {
        if (this.reExpEmail.test(this.state.email.emailStr)) {
            if (this.newEmail) {
                this.loading();
                this.emailAdminService.addNewEmailAdmin(this.state.email.emailStr)
                    .then(dataEmails => this.fillDataEmails(dataEmails));
                this.setState({
                    email: null,
                    displayDialog: false,
                })
            }
        } else {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Correo no válido.'
            });
        }
    }

    deleteEmail() {
        this.loading();
        this.emailAdminService.deleteEmailAdmin(this.state.emailDelete.emailStr)
            .then(dataEmails => this.fillDataEmails(dataEmails));
    }

    searchEmail() {
        if ((this.reExpEmail.test(this.state.emailSearch)) || (this.state.emailSearch === '')) {
            this.loading();
            this.setState({
                dataEmails: this.getDataEmail(this.state.emailSearch),
            })
        } else {
            this.growl.show({severity: 'error', summary: 'Error.', detail: 'Correo no válido.'});
        }
    }

    onHideDialog() {
        this.setState({displayDialog: false});
    }

    onChangeTextDialog(event) {
        const {id, value} = event.target;
        let email = this.state.email;
        email[id] = value;
        this.setState({email: email,})
    }

    onChangeTextFilter(event) {
        const {value} = event.target;
        this.setState({emailSearch: value,})
    }

    clearFilters() {
        this.setState({emailSearch: ''})
    }

    emailActionTemplate(rowData, column) {
        return (
            <ConfirmationMessage nameButton="Eliminar"
                                 legend="¿Está seguro que desea eliminar el registro?"
                                 action={this.deleteEmail}
            />
        );
    }

    handleSelectEmail = (event) => {
        this.setState({
            emailDelete: event.value,
        });
    };

    render() {
        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-6" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}>Insertar correo</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-3" style={{padding: '.2em'}}>
                    <Button label="Cancelar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-3" style={{padding: '.2em'}}>
                    <Button label="Guardar" onClick={this.saveEmail}/>
                </div>
            </div>;

        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        const {dataEmails, displayDialog, email, emailSearch, isLoading} = this.state;

        return <EmailAdmin dataEmails={dataEmails}
                           dialogHeader={dialogHeader}
                           displayDialog={displayDialog}
                           email={email}
                           isLoading={isLoading}
                           emailSearch={emailSearch}
                           messagesGrowl={messagesGrowl}
                           onHideDialog={this.onHideDialog}
                           onChangeTextDialog={this.onChangeTextDialog}
                           emailActionTemplate={this.emailActionTemplate}
                           onChangeTextFilter={this.onChangeTextFilter}
                           clearFilters={this.clearFilters}
                           searchEmail={this.searchEmail}
                           handleSelectEmail={this.handleSelectEmail}
                           addNewEmail={this.addNewEmail}
                           emailDelete={this.state.emailDelete}
        />
    }
};